import * as S from './index.style'
import Checkbox from '@material-ui/core/Checkbox'
import { DadosGarantias } from 'models/Viabilidade/Garantias'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { useState } from 'react'
import { secaoOpcional } from 'helpers/Constantes/Mensagens'

export type GarantiasProps = {
  /** Descricao do que a prop faz, vai direto pro storybook */
  dadosGarantias: DadosGarantias
  dadosGarantiasHandler: (novoValor: DadosGarantias) => void
}

/** Descricao do que o componente faz, vai direto pro storybook */
const Garantias: React.FC<GarantiasProps> = ({ dadosGarantias, dadosGarantiasHandler }) => {
  const [valores, setValores] = useState(dadosGarantias)

  const checkboxHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const state = { ...valores, [event.target.name]: event.target.checked }

    setValores(state)
    dadosGarantiasHandler(state)
  }

  return (
    <S.Wrapper data-cy="sessaoGarantias">
      <S.NomeSecao>
        Garantias <S.SecaoOpcional>{secaoOpcional}</S.SecaoOpcional>
      </S.NomeSecao>
      <S.ContainerFlex>
        <S.CampoCheckbox>
          <FormControlLabel
            value="start"
            control={<Checkbox color="secondary" name="FiancaBancariaTerreno" onChange={checkboxHandler} />}
            label="Fiança Bancária Terreno"
            labelPlacement="end"
            checked={dadosGarantias.FiancaBancariaTerreno}
            data-cy="campoFiancaBancariaTerreno"
          />
        </S.CampoCheckbox>
        <S.CampoCheckbox>
          <FormControlLabel
            value="start"
            control={<Checkbox color="secondary" name="SeguroGarantiaUrbanizacao" onChange={checkboxHandler} />}
            label="Seguro Garantia Urbanização"
            labelPlacement="end"
            checked={dadosGarantias.SeguroGarantiaUrbanizacao}
            data-cy="campoSeguroGarantiaUrbanizacao"
          />
        </S.CampoCheckbox>
        <S.CampoCheckbox>
          <FormControlLabel
            value="start"
            control={<Checkbox color="secondary" name="SeguroGarantiaPermutaFisica" onChange={checkboxHandler} />}
            label="Seguro Garantia Permuta Física"
            labelPlacement="end"
            checked={dadosGarantias.SeguroGarantiaPermutaFisica}
            data-cy="campoSeguroGarantiaPermutaFisica"
          />
        </S.CampoCheckbox>
      </S.ContainerFlex>
    </S.Wrapper>
  )
}

export default Garantias
